import React, {Component} from 'react';

import Search from "../core/Search";

class Utilisateurs extends Component {

    constructor(props) {
        super(props);

        this.externalCall = this.externalCall.bind(this);
    }

    externalCall(method) {
        if (method === "addUtilisateur") {
            this.props.history.push('/admin/utilisateur/');
        }
    }

    render() {
        return (
            <Search
                initData={{DATAGRID_SCREEN_ID: 104}}
                externalCall={this.externalCall} />
        );
    }
}

export default Utilisateurs;
